/**
 * Users Management
 * Gestão de usuários da plataforma
 */
import { Search, Filter, UserPlus } from 'lucide-react'

export default function Users() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white">Usuários</h1>
          <p className="text-slate-400">Gestão de usuários da plataforma</p>
        </div>
        <button className="btn-admin flex items-center gap-2">
          <UserPlus className="w-4 h-4" />
          Novo Usuário
        </button>
      </div>
      
      <div className="admin-card">
        <div className="flex items-center gap-4 mb-6">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <input
              type="text"
              placeholder="Buscar usuários..."
              className="admin-input pl-10"
            />
          </div>
          <button className="btn-secondary flex items-center gap-2">
            <Filter className="w-4 h-4" />
            Filtros
          </button>
        </div>
        
        <div className="text-center py-12">
          <p className="text-slate-400">Em desenvolvimento...</p>
        </div>
      </div>
    </div>
  )
}

